export default "__VITE_ASSET__CKrMa2oj__"